import { useState, useEffect, useCallback } from "react";
import shopify from "frontend/js/shopify";
import helpers from '../../js/helpers';
import { DEFAULT_TRENDING_QUERIES } from '../../js/alpine/components/search/searchspring/searchspring';
import { StatsProps, useSearch, useResults, useReactifySearchContext } from "@usereactify/search";

function useReactify(collection = null) {

    const [products, setProducts] = useState([]);
    const [filters, setFilters] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [searchResultsFacets, setSearchResultsFacets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);
    const [sortingOptions, setSortingOptions] = useState([]);
    const [sortOption, setSortOption] = useState('');

    const itemsPerPage = 13; // Number of items to load per page
    // Call the `useSearch` hook at the top level of the custom hook

    const searchHook = useSearch();

    async function reactifySearch(q) {
        console.log("Searching from Reactify:", q);
        try {
            if (q !== "") {
                console.log('Search query', q);
                setLoading(true);
                searchHook.setSearchTerm(q);
                const searchData = await searchHook.submitSearchQuery({
                    "query": {
                        "term": {
                            "title": q
                        }
                    },
                });

                console.log("Search data:", searchData);
                // const transformedProducts = await transformProducts(searchData?.results);

                setSearchResults(searchData.results);
                setTotalResults(searchData?.resultStats.numberOfResults);
                // setSearchResultsFacets(searchData?.facets);

                window.dispatchEvent(
                    new CustomEvent("searchrequest-products-complete", {
                        detail: {
                            query: q,
                            products: searchData.results,
                            totalResults: searchData?.resultStats.numberOfResults,
                            filters: filters,
                            type: "header",
                            page: 1,
                            isFiltering: false,
                        },
                    })
                );

                return true;
            }
        } catch (err) {
            console.error("Failed to fetch autocomplete results:", err);
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    }

    const transformProducts = useCallback(async (products) => {
        if (!products || products.length === 0) return [];

        const productIds = [...new Set(products.map(product => product.uid || product.mappings?.core?.uid))];

        try {
            const shopifyProducts = await shopify.getShopifyProductList(productIds);
            const productsWithColorPattern = await Promise.all(
                shopifyProducts.map(async (shopifyProduct) => {
                    const { metafields } = shopifyProduct;
                    const productSiblingsArr = metafields.find(item => item.key === "product_siblings");

                    let colorPatterns = [];

                    if (productSiblingsArr) {
                        const siblingsRefArr = productSiblingsArr.references.edges;
                        const productSiblingIds = siblingsRefArr.map(sibling => sibling.node.metafields[0].value);

                        // Fetch color pattern data for each sibling
                        colorPatterns = await Promise.all(productSiblingIds.map(async (id) => {
                            const colorPatternQuery = shopify.getColorPatternQuery(helpers.cleanupGlobalId(id));
                            const colorPatternData = await shopify.fetchGraphQL(colorPatternQuery);

                            return colorPatternData?.metaobject?.fields || [];
                        }));

                        colorPatterns = colorPatterns.map((colorPatternArray, index) => {
                            const colorPatternObject = {};
                            colorPatternArray.forEach(item => {
                                if (item.key === "image" && item.reference?.previewImage?.src) {
                                    colorPatternObject[item.key] = item.reference.previewImage.src;
                                } else {
                                    colorPatternObject[item.key] = item.value;
                                }
                            });
                            colorPatternObject['url'] = '/products/' + siblingsRefArr[index]?.node?.handle || '';

                            return colorPatternObject;
                        });
                    }

                    return {
                        ...shopifyProduct,
                        colorPatterns,
                    };
                })
            );

            const productsWithTog = shopifyProducts.map(product => {
                const { metafields } = product;
                const productTogArr = metafields.find(item => item.key === "tog_rating");

                let productTogs = [];

                if (productTogArr) {
                    const togRefArr = productTogArr.references.edges;

                    productTogs = togRefArr.map(togNode => {
                        const togObj = {};
                        const node = togNode.node;

                        // Extract the tog_title and tog_colour
                        togObj['tog_colour'] = node.tog_colour?.value;
                        togObj['tog_title'] = node.tog_title?.value;

                        return togObj;
                    });
                }

                return {
                    ...product,
                    productTogs,
                };
            });

            return products.map(product => ({
                ...product,
                ...productsWithColorPattern.find(shopifyProduct => shopifyProduct.id === parseInt(product.uid || product.mappings?.core?.uid)),
                ...productsWithTog.find(shopifyProduct => shopifyProduct.id === parseInt(product.uid || product.mappings?.core?.uid)),
            }));
        } catch (err) {
            console.error('Failed to transform products using Shopify:', err);
            return products;
        }
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const initialFilters = [];

        params.forEach((value, key) => {
            initialFilters.push(`${key}=${value}`);
        });

        const filterString = initialFilters.join("&");
        setSelectedFilters(`?${filterString}`);
        // handleProductListing(currentPage, `?${filterString}`);
    }, [currentPage, sortOption]);

    useEffect(() => {
        if (selectedFilters) {
            // handleProductListing(currentPage, selectedFilters);
        }
    }, [selectedFilters]);

    // useEffect(() => {
    //   if (searchQuery) {
    //     handleAutocomplete(searchQuery);
    //   }
    // }, [searchQuery, handleAutocomplete]);

    return {
        products,
        filters,
        loading,
        error,
        totalResults,
        sortingOptions,
        searchResults,
        searchResultsFacets,
        reactifySearch
    };
}

export default useReactify;